<template>
  <div class="">
    <div class="row" v-if="!$session.has('CustomerInfo')">
      <div class="col-12 col-md-12" v-for="(item, index) in RowsUser" :key="index">
        <Card>
          <template slot="header">
            <div class="row">
              <div class="col-md-1 col-3 m-0">
                <h4 class="d-inline"><i class="fad fa-bell text-warning"></i></h4>
              </div>
              <div class="col-md-3 col-3 Pointer" title="برای نمایش متن کامل کلیک کنید" @click="OpenModal(item)">
                <h6 class="d-inline">{{ item.Title.length > 20 ? item.Title.slice(0, 20) + ' ... ' : item.Title }}</h6>
              </div>
              <div class="col-md-6 col-3 Pointer" title="برای نمایش متن کامل کلیک کنید" @click="OpenModal(item)">
                <h6 class="d-inline">{{ item.Message.length > 35 ? item.Message.slice(0, 40) + ' ... ' : item.Message }}</h6>
              </div>
              <div class="col-md-2 col-3">
                <h6 class="d-inline" @click="CloseMessage(item.Id)" title="مشاهده شد">
                  <i class="fas fa-times font-weight-bold hover-danger float-left my-2 Pointer"></i>
                </h6>
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>
    <div class="row mb-4" v-if="$session.has('CustomerInfo')">
      <div class="col-12 col-md-12">
        <Card class="Max_Height" v-if="Rows.length>0">
          <template slot="header" >
            <div  v-for="(item, index) in Rows" :key="index" class="row mt-3"  >
              <div class="col-md-1 col-3 m-0">
                <h4 class="d-inline "><i class="fas fa-bell text-warning animate__animated animate__tada animate__infinite"></i></h4>
              </div>
              <div class="col-md-9 col-3">
                <!-- <h6 class="d-inline" :title="item.Title">{{ item.Title.length > 20 ? item.Title.slice(0, 20) + ' ... ' : item.Title }}</h6> -->
                <h6 class="d-inline" :title="item.Title">{{item.Title }}</h6>
              </div>
              <!-- <div class="col-md-6 col-3"> -->
                <!-- <h6 class="d-inline" :title="item.Message">{{ item.Message.length > 35 ? item.Message.slice(0, 40) + ' ... ' : item.Message }}</h6> -->
              <!-- </div> -->
              <div class="col-md-2 col-3">
                <h6 class="d-inline">
                  <i class="fas fa-eye font-weight-bold hover-warning float-left my-2 Pointer" @click="OpenModal(item)" title="مشاهده متن پیام"></i>
                </h6>
              </div>
              <hr/>
            </div>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>
<script>
import Card from '../../../components/Card/Card.vue'
export default {
  components: { Card },
  data() {
    return {
      Rows: [],
      RowsUser: [],
      RowsUserRiz: [],
    }
  },
  methods: {
    GetRow() {
      this.Rows = []
      let DataAxios_GetNotices = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'NoticeBoard/Get_BoardUserDashboard',
        Token: this.$session.get('Token'),
      }
      if (this.$session.has('CustomerInfo')) {
        DataAxios_GetNotices.ArryfildValue.IsCustomer = true
      } else {
        DataAxios_GetNotices.ArryfildValue.IsCustomer = false
      }
      this.$PostData(DataAxios_GetNotices)
        .then((data) => {
          this.Rows = data.Result
          if (this.$session.has('CustomerInfo')) {
            this.Rows = data.Result.filter((el) => el.IsCustomer == true)
          } else {
            this.OnDetail()
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    OnDetail() {
      this.RowsUser = []
      let DataAxios_GetNoticesDetail = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'NoticeBoard/Get_BoardDetail',
        Token: this.$session.get('Token'),
      }
      DataAxios_GetNoticesDetail.ArryfildValue.tblNoticeBoardId = 0
      this.$PostData(DataAxios_GetNoticesDetail)
        .then((data) => {
          let n = 0
          data.Result.forEach((element) => {
            if (element.ReadMessage == false && element.tblUserId == this.$session.get('UserInfo').tblUserId) {
              this.Rows.forEach((x) => {
                if (x.Id == element.tblNoticeBoardId) {
                  this.RowsUser.push(x)
                  this.RowsUser[n].Id = element.Id
                  n++
                }
              })
              //   this.RowsUser.push(this.Rows.find(el=>el.Id==element.tblNoticeBoardId))
              //   this.RowsUserRiz.push(element)
            }
          })
        })
        .finally(() => {
          this.$store.state.renderComponentGridModal = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGridModal = true
          })
        })
    },
    CloseMessage(Id) {
      this.$SweetQustion(' عدم نمایش اعلان', 'از نمایش ندادن این اعلان اطمینان دارید؟', 'warning', 'اطمینان دارم', 'انصراف', Id, this.ReadMessage, this.cancel)
    },
    ReadMessage(id) {
      let DataAxios_ReadMessage = {
        ArryfildValue: { tblNoticeBoardId: id },
        Method: 'post',
        Action: 'NoticeBoard/ReadMessage',
        Token: this.$session.get('Token'),
      }
      this.RowsUserRiz.forEach((element) => {
        if (element.ReadMessage == false && element.tblNoticeBoardId == id && element.tblUserId == this.$session.get('UserInfo').tblUserId) {
          DataAxios_ReadMessage.ArryfildValue.tblNoticeBoardId = element.Id
        }
      })
      this.$PostData(DataAxios_ReadMessage)
        .then((data) => {
          this.Rows = []
          this.RowsUser = []
          this.RowsUserRiz = []
          this.GetRow()
          this.OnDetail()
        })
        .finally(() => {
          this.$store.state.renderComponentGridModal = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGridModal = true
          })
        })
    },
    OpenModal(rowSelected) {
      this.$emit('DataNoticeBoard', rowSelected)
    },
  },
  mounted() {
    this.GetRow()
    
  },

}
</script>
<style scoped>
.animate__animated.animate__shakeX {
  --animate-duration: 2s;
  font-size: 28px;
}

.Max_Height{
  max-height: 210px;
  /* overflow-y: scroll; */
}
</style>
